// import eight from '../assets/svg/projects/eight.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import six from '../assets/svg/projects/six.svg'
// import face from '../assets/png/face.jpg'
// import land from '../assets/png/land.jpg'
//import handloom from '../assets/png/handloom.jpg'
import cur from '../assets/png/cur.jpg'
import gen from '../assets/png/gen.jpg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Cursor movement on object',
        projectDesc: 'A project is to enable hands-free computer interaction through gesture-based controls like cursor movement and clicks.',
        tags: ['OpenCV', 'Mediapipe', 'PyAutoGUI', 'NumPy'],
        code: 'https://github.com/BhavyashreeKP',
        demo: 'https://github.com/BhavyashreeKP',
        image: cur
    },
    {
        id: 2,
        projectName: 'Genzeed',
        projectDesc: 'A Platform that turns climate education into short, reliable, and engaging stories to close the gap between concern and action.',
        tags: ['React.js', 'tailwind', 'Node.js', 'Express.js', 'MongoDB'],
        code: 'https://github.com/BhavyashreeKP',
        demo: 'https://github.com/BhavyashreeKP',
        image: gen
    },
    // {
    //     id: 3,
    //     projectName: 'WeaveQuest: Exclusive Handloom Saree Marketplace',
    //     projectDesc: 'A dedicated online platform celebrating the tradition of handloom sarees, connecting artisans and enthusiasts in a vibrant marketplace.',
    //     tags: ['React', 'CSS' , 'HTML'],
    //     code: 'https://github.com/srinivaspavan73/Weaver-s-Loom',
    //     demo: 'https://weavers-loom.netlify.app/',
    //     image: handloom
    // }
        
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/